import React, { useState } from 'react';
import './TutorialBanner.css';

export default function TutorialBanner({ description, onDismiss }) {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  const handleDismiss = () => {
    try {
      if (typeof onDismiss === 'function') onDismiss();
    } finally {
      setVisible(false);
    }
  };

  return (
    <div className="tut-banner">
      <div className="tut-banner__body">
        {description && <div className="tut-banner__desc">{description}</div>}
        <div className="tut-banner__actions">
          <button className="tut-banner__btn tut-banner__btn--link" onClick={handleDismiss}>Dismiss</button>
        </div>
      </div>
    </div>
  );
}


